// extracted by mini-css-extract-plugin
module.exports = {"ripple":"style_ripple__1liSx"};